import React from "react";
import { toLower } from "lodash";
import { ActionText, Flex } from "../../components/Flex";
import { Input } from "../../components/Input";
import { SearchIcon } from "../../icons/SearchIcon";
import { SmallCloseIcon } from "../../icons/SmallCloseIcon";

const SearchDetailsBox = ({ visible, value, onSearch, onExpand, onCollapse }) => {

    return(
        visible
            ? <Flex align="center">
                <Input
                    autoFocus
                    height="24px"
                    style={{ borderBottom: "1px solid #B8C0E2", marginRight: "8px" }}
                    onChange={(e) => onSearch(toLower(e.target.value))}
                    value={value}
                />
                <SmallCloseIcon
                    color="var(--sp-error-color)"
                    hoverColor="var(--sp-error-hover-color)"
                    onClick={() => onCollapse()}
                />
            </Flex>
            : <ActionText onClick={() => onExpand()}>
                <SearchIcon />
            </ActionText>
    )
};

export { SearchDetailsBox };